export const UPDATE_SOURCES_DATA = 'action.sources.update.data';

export const updateSourcesData = data => {
    return {
        type: UPDATE_SOURCES_DATA,
        data,
    };
};
